import type { UserAuth } from '~/schemas/auth'

/**
 * Path-based access control middleware.
 * Enforces URL prefix access restrictions as an extra security layer:
 * - /platform/* → only accessible if subscriber_id is NULL (platform roles)
 * - /agency/* → only accessible if has subscriber_id (subscriber roles) or platform admin in subscriber context
 */
export default defineNuxtRouteMiddleware((to) => {
  const { user } = useSanctumAuth<UserAuth>()

  if (!user.value?.current_role) return

  const path = to.path
  const role = user.value.current_role

  // /platform/* — only platform users (subscriber_id = NULL)
  if (path.startsWith('/platform')) {
    if (role.subscriber_id) {
      throw showError({
        statusCode: 403,
        statusMessage: 'Nemate dozvolu za pristup ovoj stranici',
      })
    }
  }

  // /agency/* — subscriber users OR platform admins in subscriber context
  if (path.startsWith('/agency')) {
    const isPlatformRole = ['super-admin', 'platform-admin'].includes(role.role)
    if (!role.subscriber_id && !isPlatformRole) {
      throw showError({
        statusCode: 403,
        statusMessage: 'Nemate dozvolu za pristup ovoj stranici',
      })
    }
  }
})
